<template src="./DD_Home.HTML"></template>
<style src="./Data_Tools.css" scoped></style>
<style>
#ptv-map .ol-attribution {
  /* Inline, just left of the Help pill (~3em wide at right: .5em). */
  bottom: .5em !important;
  right: 4.5em !important;
}

.fly-clone {
  transition: transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94),
              opacity 0.5s ease,
              scale 0.5s ease;
  background: #007bff;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  pointer-events: none;
  will-change: transform, opacity;
}
</style>
<script>
// PTV imports
import DT_ChangePassword from './DT_ChangePassword.vue'
import DT_ReleaseNotes from './DT_ReleaseNotes.vue'
import DT_Measurement from './DT_Measurement.vue'
import MMP_MapSettings from '../shared/MMP_MapSettings.vue'
import DT_ReleaseHistory from './DT_ReleaseHistory.vue'
import DT_LayerList from './DT_LayerList.vue'
import DT_ReleaseModal from './DT_ReleaseModal.vue'
import DT_Widgets from './DT_Widgets.vue'
import DD_Dashboard from './DD_Dashboard.vue'
import DT_NavBar from './DT_NavBar.vue'
import DT_LatLong from './DT_LatLong.vue'
import DT_ZoomLevel from './DT_ZoomLevel.vue'
import DT_ZoomWidget from './DT_ZoomWidget.vue'
import DT_Tutorial from './DT_Tutorial.vue'
import DT_Tools from './DT_Tools.vue'
import DT_Attributes from './DT_Attributes.vue'
import MMP_LoadingScreen from './../shared/MMP_LoadingScreen.vue'
import MMP_LayerLegend from '../shared/MMP_LayerLegend.vue'
import Moveable from 'vue-moveable'
// Package Imports
import axios from 'axios'
// OpenLayers imports
import 'ol/ol.css'
import Attribution from 'ol/control/Attribution'
import Map from 'ol/Map'
import View from 'ol/View'
import Point from 'ol/geom/Point'
import { GeoJSON } from 'ol/format'
import { OSM, XYZ } from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import { unByKey } from 'ol/Observable'
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Style, Stroke, Fill, Text, Circle, RegularShape } from 'ol/style';
import Select from 'ol/interaction/Select';
import { click, never } from 'ol/events/condition';
import Feature from 'ol/Feature'
import { addDays, createLayers } from '../../../utils/utils.js'
import {
  get as projGet,
  fromLonLat,
  toLonLat,
  transform,
  transformExtent,
  get
} from 'ol/proj'

import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'DD_Home',
  components: {
    DT_ChangePassword,
    DT_ReleaseNotes,
    MMP_MapSettings,
    DT_ReleaseHistory,
    DT_LayerList,
    DT_ReleaseModal,
    DT_Widgets,
    DD_Dashboard,
    DT_NavBar,
    DT_LatLong,
    DT_ZoomLevel,
    DT_Measurement,
    DT_ZoomWidget,
    DT_Tutorial,
    DT_Tools,
    DT_Attributes,
    Moveable,
    MMP_LoadingScreen,
    MMP_LayerLegend
  },
  data() {
    return {
      app: 'DD_Home',
      dmpWhiteImg: require('../../../assets/dmpWhite.png'),
      user: null,
      versionReleaseInfo: null,
      isUshrUser: false,
      mapsMode: false,
      map: null,
      currentBaseMap: null,
      selectedExtent: null,
      drtLayersButtonsCtrl: [],
      ptv_layersObj: {},
      spinnerManager: [],
      layerResponse: null,
      ptv_layers: [],
      lidarIsLoading: false,
      olMapMoveStartKey: null,
      olMapMoveEndKey: null,
      zoomStarted: null,
      zoomControlArr: null,
      shortTermLayerMemory: [],
      zoomEnded: null,
      zoomLevelCap: 13,
      zoomLevel: null,
      showLidarPanel: false,
      olImageLoadStartKey: null,
      olImageLoadEndKey: null,
      olImageLoadErrorKey: null,
      olTileLoadStartKey: null,
      olTileLoadEndKey: null,
      olTileLoadErrorKey: null,
      olSelectkey: null,
      legendImgSrc: null,
      layerLegendName: null,
      layerLegend: false,
      layerLegendMaxHeight: null,
      layerLegendMinimized: false,
      selectedRelease: null,
      extentResponse: [],
      showAttributes: false,
      vectorLayer: null,
      attributesName: null,
      showMeasuringTool: false,
      showSnippingTool: false,
      polygonVectorLayers: [],
      clickedCoords: null ,// Right click coordinates on map,
      // showAISearch: false,
      isAdmin: false,
      measurement: null,
      polygonsSelected: [],
      polygonSelectEvent: null,
      tutorialTrigger: false,
      ptvMapFlag: false,
      lidarFlag: false,
      project_id: null,
      observer: null,
      distinct_lidar: [],
      extentName: null,
      features: [],
      feature_index: null,
      queryWindowResponse: null,
      fullSite: null,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        throttleDragRotate: 0
      },
      lidarMinZoomAchieved: false,
      attributesPanelMinimized: false,
      trailsLoading: false,
      distinct_trails: [],
      showTrailsPanel: false,
      selectedTrails: [],
      cart: [],
      showLoadingScreen: true,
      menuCollapsed: false,
      ddtAdminAccounts: []
    }
  },
  async mounted() {
    this.showLoadingScreen = true
    await this.initPTV()
    if (!sessionStorage.pid && !typeof sessionStorage.pid == "string") {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      this.$emit('clearCurrentPositionsInterval')
      this.$router.push({name: 'Login'})
    }

    if (this.$route.query.openMap) {
      await this.$nextTick(() => {
        this.mapsMode = true;
        this.loadProject('Maps');
      })
    } else {
      this.showLoadingScreen = false
    }

    this.getDDTAdminAccounts();
  },
  created() {
    window.addEventListener('beforeunload', this.handlerClose)
  },
  watch: {
    '$route.query.dashboard'(val) {
      if (val === '1') {
        this.mapsMode = false
        this.reset();
      }
    }
  },
  methods: {
    async reset(done) {
      if (this.showLidarPanel) {
        this.toggleLidarPanel();
      }
      if (this.showTrailsPanel) {
        this.toggleTrailsPanel();
      }
      await this.observer?.disconnect();
      await this.destroyMap();
      this.persistingLayerFilters = []
      this.showLidarPanel = false;
      this.ptvMapFlag = false;
      this.lidarFlag = false;
      this.showLidarPanel = false;
      this.selectedRelease = null;
      this.selectedTrails = [];
      this.cart = [];
      if (done) {
        done();
      }
    },
    toggleMeasuringTool() {
      this.showMeasuringTool = !this.showMeasuringTool
    },
    toggleSnippingTool() {
      this.showSnippingTool = !this.showSnippingTool
    },
    async getLayers(release) {
      this.drtLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      this.drtLayersButtonsCtrl = []
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/layer/release', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              extent: release.extent_description,
              release_id: release.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('release API Call Error: ' + content.errors)
            } else {
              const layerLinks = []
              this.layerResponse = content
              content.filter(e => e.visibility != false).forEach(link => {
                let linkObj = link.link_object
                let linkObjLayerGroup = linkObj.info.layer_group
                // Replaces all underscores with spaces
                let output = linkObj.name.replace(/_/g, ' ')
                let objToPush = {
                  name: linkObj.name,
                  zoomControl: linkObj.zoomControl,
                  display_name: output,
                  layer_group: linkObjLayerGroup,
                  minZoom:
                    linkObj.minZoom == undefined ? null : linkObj.minZoom,
                  layer_definition:
                    linkObj.layerDefinition == undefined
                      ? null
                      : linkObj.layerDefinition,
                  fullMap: linkObj.fullMap
                }
                linkObj['display_name'] = output
                layerLinks.push(linkObj)
                this.drtLayersButtonsCtrl.push(objToPush)
              })

              this.ptv_layers = layerLinks

              // The map may have been torn down (destroyMap) while the request
              // was in flight, leaving this.map null — skip map-dependent setup.
              if (this.map) {
                this.ptv_layersObj = createLayers(this.ptv_layers, this.map)

                this.drtLayersButtonsCtrl.forEach(layerobj => {
                  this.unloadLayers(layerobj.name)
                })
                new unByKey(this.olMapMoveStartKey)
                new unByKey(this.olMapMoveEndKey)
                this.setListeners()
              }
            }
          })
      } else {
        console.log('No User Token')
      }
    },
    setListeners() {
      this.olMapMoveStartKey = this.map.on('movestart', evt => {
        this.lidarIsLoading = true
        this.trailsLoading = true
        this.zoomStarted = this.map.getView().getZoom()
      })
      this.olMapMoveEndKey = this.map.on('moveend', evt => {
        this.zoomControlArr = this.zoomControlLayers(this.ptv_layersObj)
        this.zoomEnded = this.map.getView().getZoom()

        // Zoom controlled layer handling
        for (let i in this.zoomControlArr) {
          let zoomLayer = this.zoomControlArr[i]
          let layerIndex = this.shortTermLayerMemory.indexOf(
            zoomLayer.ButtonName
          )
          let layerRemembered = layerIndex != -1
          let item = document.getElementById(zoomLayer.ButtonName)
          let showLayer =
            zoomLayer.minZoom == null
              ? this.zoomEnded >= this.zoomLevelCap
              : this.zoomEnded >= zoomLayer.minZoom
          if (item) {
            // If user is zoomed in enough...
            if (showLayer) {
              /* If the layer exists in short term memory,
              remove it since the layer is being enabled. */
              if (layerRemembered) {
                this.toggleLayerVisibility(zoomLayer.ButtonName) // TODO: need this fn eventually
                this.shortTermLayerMemory.splice(layerIndex, 1)
              }
            } else {
              this.map.getLayers().forEach(layer => {
                if (layer.get('name') == zoomLayer.ButtonName) {
                  /* If turning the layer off, add it to short term layer
                  memory to be enabled again later. */
                  if (!layerRemembered) {
                    this.shortTermLayerMemory.push(zoomLayer.ButtonName)
                  }
                }
              })
              this.unloadLayers(zoomLayer.ButtonName)
            }
          }
        }

        // Lidar zoom warning handling
        if (this.showLidarPanel) {
          this.lidarDownload(this)
        }
        if (this.showTrailsPanel) {
          this.trailDownload(this)
        }
        this.setLidarMinZoomAchieved(this.zoomEnded >= 17)
      })
    },
    // This function generates the button list to be disabled even on zoom in and zoom out
    zoomControlLayers(layers) {
      let zoomAr = []
      for (let key in layers) {
        if (layers[key].zoomControl) {
          zoomAr.push({
            layer: layers[key].layer,
            ButtonName: key,
            minZoom:
              layers[key].minZoom == undefined ? null : layers[key].minZoom
          })
        }
      }
      return zoomAr
    },
    datasetSelected(release) {
      this.selectedRelease = release
      if (this.selectedRelease.extent_description != this.selectedExtent) {
        let extent = this.extentResponse.filter(e => e.extent_description == this.selectedRelease.extent_description)[0]
        this.changeExtent(extent)
      }
      this.selectedExtent = release.extent_description
      this.getLayers(release)
      this.tutorialTrigger = true
      this.$bvModal.hide('ptvReleaseModal')
    },
    destroyMap() {
      if (this.map) {
        this.map.setTarget(null); // Disconnects map from DOM
        this.map.getLayers().clear();
        this.map = null;
        this.polygonsSelected = [];
        this.polygonVectorLayers = [];
        this.drtLayersButtonsCtrl = [];
      }

      this.closeLegend()

      // this.mapsMode = false;
      this.selectedExtent = 'North America'
    },
    async loadProject(project) {
      this.selectedRelease = null
      switch(project) {
        case 'Maps':
          this.initMaps();
          if (!this.menuCollapsed) {
            this.toggleCollapse()
          }
          this.project_id = 35;
          this.lidarFlag = false;
          this.ptvMapFlag = true;
          this.$bvModal.show('ptvReleaseModal')
          break;
      }
    },
    toggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed
    },
    initMaps() {
      this.mapsMode = true
      this.$nextTick(() => {
        this.map = new Map({
          controls: [new Attribution({ collapsible: true })],
          target: 'ptv-map',
          pixelRatio: 1,
          layers: [
              new TileLayer({
                source: new OSM(),
                name: 'OSM base layer',
                zIndex: 2
              })
          ],
          view: new View({
            center: [0, 0],
            zoom: 2,
            maxZoom: 21
          }),
        });

        this.currentBaseMap = 'OpenStreetMap'

        this.map.getViewport().addEventListener('contextmenu', evt => {
          evt.preventDefault()
          let coords = toLonLat(this.map.getEventCoordinate(evt, 'EPSG:4326'))
          this.clickedCoords = coords // this will trigger copy function in PTV_LatLong
        })

        const mapDOMElement = document.getElementById('ptv-map')
        this.observer = new ResizeObserver(() => {
          this.map?.updateSize();
        })

        this.observer.observe(mapDOMElement)

        this.transformExtent(this.extentResponse)

        this.showLoadingScreen = false;
      })
    },
    async initPTV() {
      await this.getUser();
      await this.getExtent();
    },
    async getUser() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/auth', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            let info = response.data
            let auth = info.authorization
            this.user = {
              email: info.email,
              id: info.id,
              inactive: info.inactive,
              name: info.name,
              org: info.org,
              role: auth.permissions,
              test: auth.testAccount == 'True',
              group: auth.group,
              extent: info.extent_id != null ? info.extent_id : null,
              isAdmin: this.globalIsUserAllowed('Data_Delivery_Tool_Admin_Dashboard'),
              tutorial_acknw: info.tutorial_acknw ? info.tutorial_acknw : {}
            }
            this.isUshrUser = info.org == 1
            // REFACTOR SUGGESTION -- WEBGIS-2548 -- self.user.errors is never going to be true here. Self.user is set above
            if (this.user.errors) {
              this.$router.push({ name: 'Login' })
            }
            if (this.user != null) {
              this.$refs.ReleaseNotesRef.getVersionRelease(this.user)
              this.getReleaseVersion()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }

      return Promise.resolve(true)
    },
    getReleaseVersion() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/checkReleaseVersion', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: { id: this.user.org }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('checkReleaseVersion API Call Error: ' + content.errors)
            } else {
              this.versionReleaseInfo = content[0]
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    async getDDTAdminAccounts() {
        if (sessionStorage.token) {
            await axios.get(
                `${process.env.API_LOCATION}/api/dataDeliveryTool/getAdmin`,
                { headers: { 'x-auth-token': sessionStorage.token } }
            )
            .then(response => {
                this.ddtAdminAccounts = response.data.map(u => u.id)
            })
            .catch(function (error) {
                console.log(error)
            })
        }
    },
    async sendAdminNotifications(obj) {
        const d = new Date();

        const timestamp = d.toLocaleDateString(navigator.language, { month:'2-digit', day: '2-digit', year: 'numeric'}) 
                        + ", " + d.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})
        
        let msg = `A new Data sample request has been submitted by ${this.user.name}.
                    \nRequest Details: 
                    **REGION: ${obj.region}
                    **Requested Delivery Date: ${obj.deliveryDate}
                    **Requested Delivery Type: ${obj.deliveryType}
                    **Created Date: ${timestamp}

                    \nThe request is now available for review.`

        this.ddtAdminAccounts.forEach(user_id => {
          this.pushNotification({msg: msg, user_id: user_id})
        })
    },
    pushNotification(obj) {
        if (sessionStorage.token) {
            axios.post(
                `${process.env.API_LOCATION}/api/dataDeliveryTool/sendNotification`,
                {
                msg: obj.msg,
                to_user_id: obj.user_id
                },
                { headers: { 'x-auth-token': sessionStorage.token } }
            )
            .catch(function (error) {
                console.log(error)
            })
        }
    },
    handlerClose() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
    },
    unloadLayers(layerNameToToggle) {
      let layer
      if (this.ptv_layersObj[layerNameToToggle] != null) {
        layer = this.ptv_layersObj[layerNameToToggle].layer
      }

      if (layer) {
        // Unloading layer function
        this.map.removeLayer(layer)
        // Removes layer that has been turned off from spinnerManager
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      }
    },
    toggleLayerVisibility(layerNameToToggle) {
      if (layerNameToToggle == 'OSM') {
        this.map.getLayers().forEach(layer => {
          if (layer != undefined && layer.get('name') != undefined) {
            if (!layer.get('name').includes('OSM')) {
              this.toggleBaseLayer('Azure')
            }
          }
        })
      } else {
        if (this.ptv_layersObj.hasOwnProperty(layerNameToToggle)) {
          const layer = this.ptv_layersObj[layerNameToToggle].layer

          // If the layer doesn't exist on the map, add it to the map
          if (!this.checkLayer(layer)) {
            this.toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle)
            this.map.addLayer(layer)
            this.getLegend(layerNameToToggle)
          } else {
            this.toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle)
          }
        }
      }
    },
    toggleBaseLayer(newBaseLayer) {
      this.resetBaseLayer()
      this.currentBaseMap = newBaseLayer // REFACTOR SUGGESTION -- WEBGIS-2548 -- I feel like this could break something if newBaseLayer doesn't match any of the below options
      switch (newBaseLayer) {
        case 'OpenStreetMap':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM(),
              name: 'OSM base layer',
              zIndex: 2
            })
          )
          break
        case 'Azure':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new XYZ({
                url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${process.env.AZURE_MAPS_KEY}`,
                attributions: '© Microsoft Azure Maps',
                // Azure 'microsoft.imagery' tiles only exist up to zoom 19.
                // Cap the tile grid so OpenLayers over-zooms (upscales) the z19
                // tiles past 19 instead of requesting missing tiles (black map).
                maxZoom: 19
              }),
              name: 'Azure base layer',
              zIndex: 2
            })
          );
          break;
        case 'Black':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM(),
              name: 'Black base layer',
              zIndex: 2,
              opacity: 0
            })
          )
          break
      }
    },
    resetBaseLayer() {
      this.map.getLayers().forEach(layer => {
        if (layer != undefined && layer.get('name') != undefined) {
          if (layer.get('name').includes('base')) {
            if (this.checkLayer(layer)) {
              this.map.removeLayer(layer)
            }
          }
        }
      })
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] == layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name == layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle) {
      /* ImageWMS spinner addition and deletion */
      // Add layer to spinnerManager when image loads/refreshes
      this.olImageLoadStartKey = layer
        .getSource()
        .on('imageloadstart', event => {
          this.spinnerManager.push(layerNameToToggle)
        })
      // Remove layer from spinnerManager when image finishes loading
      this.olImageLoadEndKey = layer.getSource().on('imageloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if image encounters a loading error
      // NOTE - Image Load Error has spelling mistake -- should probably check that the correct event (with spelling mistake) is called
      this.olImageLoadErrorKey = layer
        .getSource()
        .on('imageloadeerror', event => {
          let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
          if (layerIndex != -1) {
            this.spinnerManager.splice(layerIndex, 1)
          }
        })

      /* TileWMS spinner addition and deletion */
      // Add layer to spinnerManager when tile loads/refreshes
      this.olTileLoadStartKey = layer.getSource().on('tileloadstart', event => {
        this.spinnerManager.push(layerNameToToggle)
      })
      // Remove layer from spinnerManager when tile finishes loading
      this.olTileLoadEndKey = layer.getSource().on('tileloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if tile encounters a loading error
      this.olTileLoadErrorKey = layer.getSource().on('tileloaderror', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
    },
    toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle) {
      // Removes layer listeners
      new unByKey(this.olImageLoadStartKey)
      new unByKey(this.olImageLoadEndKey)
      new unByKey(this.olImageLoadErrorKey)
      new unByKey(this.olTileLoadStartKey)
      new unByKey(this.olTileLoadEndKey)
      new unByKey(this.olTileLoadErrorKey)
      // Removes layer that has been turned off from spinnerManager
      let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      while (layerIndex != -1) {
        this.spinnerManager.splice(layerIndex, 1)
        layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      }
      this.map.removeLayer(layer)
    },
    // This function fetches the legends for each layer for DRT on button click
    getLegend(layerName) {
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == layerName) {
          // layerUrl will be 'undefined' if getLegendUrl fails to generate a URL.
          let layerUrl = layer
            .getSource()
            .getLegendUrl(this.map.getView().getResolution())
          if (layerUrl) {
            this.legendImgSrc = `${layerUrl}&LEGEND_OPTIONS=fontAntiAliasing:true;fontSize:17;bgColor:0xffffff;fontColor:0x003a3a3a;forceLabels:on;` + '&authkey=' + sessionStorage.token
            this.layerLegendName = layerName
            // After setting legend URL, show legend component
            this.layerLegend = true
          } else {
            console.log('FAILED TO FIND URL FOR LEGEND.')
          }
        }
      })
    },
    maxOrMinLegend(bool) {
      this.layerLegendMinimized = bool
    },
    closeLegend() {
      this.layerLegend = false
    },
    // hideAIsearch(){
    //   this.showAISearch=false
    // },
    // showAIsearch(){
    //   this.showAISearch=true
    //   this.layerLegend = false
    //   this.mapsMode=false
    // },
    async getExtent() {
      if (sessionStorage.token) {
        /* This API call is made to get the response for extent at
        initialization which we can sort further as required.
        This will reduce the additional trip to the backend. */
        await axios
          .get(process.env.API_LOCATION + '/api/users/getAllExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllExtents API Call Error: ' + content.errors)
            } else {
              this.extentResponse = []
              content.forEach(element => {
                this.extentResponse.push(element)
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async transformExtent(extArray) {
      let extentValues = []
      let extentCenter = []
      let arr

      // Assign customized extent
      switch (this.selectedExtent) {
        // REFACTOR -- WEBGIS-2548 -- Commented out unused switch case options
        // REFACTOR SUGGESTION -- WEBGIS-2548 -- Should there be an option for Middle East??
        // case '"North America"':
        // case '"Continental United States"':
        default:
          arr = extArray.filter(e => e.extent_description == 'North America')
          break
        case '"Europe"':
          arr = extArray.filter(e => e.extent_description == 'Europe')
          break
        case '"Middle East"':
          arr = extArray.filter(e => e.extent_description == 'Middle East')
          break
        case '"Japan"':
          arr = extArray.filter(e => e.extent_description == 'Japan')
          break
      }

      // Need to convert the string into array of numbers for passing to the transformExtent function
      arr[0].extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      arr[0].extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })

      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view;
      view = new View({
        extent: coord,
        center: center,
        constrainOnlyCenter: true,
        zoom: 4,
        minZoom: 3,
        maxZoom: 21,
        multiWorld: true
      })

      this.map.setView(view)
    },
    changeExtent(selectedExtent) {
      this.removePolygons();
      let extentValues = []
      let extentCenter = []
      /* Need to convert the string into array of numbers for passing
      to the transformExtent function. */
      selectedExtent.extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      selectedExtent.extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view = new View({
        extent: coord,
        center: center,
        constrainOnlyCenter: true,
        zoom: 4,
        minZoom: 3,
        maxZoom: 21,
        multiWorld: true
      })
      
      this.map.setView(view)
    },
    getShowAttributes(data) {
      this.showAttributes = data
      if (!this.showAttributes) {
        // Removes circle that appears on map when user inputs coordinates to zoom to
        this.map.removeLayer(this.vectorLayer)
        this.vectorLayer = null
      }
    },
    // Loads attributes for all layer
    loadAttributes(attr) {
      let obj = attr.name
      let layer_group = attr.layer_group
      let layerResponse = attr.response
      let layerobj = null
      if (this.ptv_layersObj.hasOwnProperty(obj)) {
        layerobj = layerResponse.filter(c => {
          return (
            c.link_object.info != undefined &&
            c.link_object.info.layer_group == layer_group
          )
        })
      }
      if (layerobj != null) {
        let param = layerobj.filter(c => c.link_object.name == obj)
        if (param.length != 0) {
          /* unByKey function will disable all single-click events
          for layers other than the selected layer */
          new unByKey(this.olSelectkey)
          // This check provides dynamic names to attributes window
          this.attributesName = param[0].layer_name.replace(/_/g, ' ')
          this.olSelectkey = this.map.on('singleclick', evt => {
            if (!this.showMeasuringTool) {
              this.querySite(
                evt,
                this.ptv_layersObj[obj].layer,
                this.map,
                param[0].link_object.params.LAYERS
              )
            }
          })
        }
      }
    },
    removeAttributesWindowListener() {
      new unByKey(this.olSelectkey);
      this.olSelectkey = null;
    },
    querySite(evt, layers, map, geoserverName, cqlFilter = null) {
      const source = layers.getSource()
      if (!cqlFilter) {
        cqlFilter = source.getParams().CQL_FILTER
      }
      const viewResolution = map.getView().getResolution()
      const options = {
        INFO_FORMAT: 'application/json',
        LAYERS: geoserverName,
        CQL_FILTER: 'INCLUDE' + `${cqlFilter ? ` AND ${cqlFilter}` : ''}`,
        QUERY_LAYERS: geoserverName,
        VIEWPARAMS: null
      }
      let url =
        source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          'EPSG:3857',
          options
        ) + '&FEATURE_COUNT=100&buffer=5&format_options=callback:getJsonFeature&authkey=' + sessionStorage.token

      if (sessionStorage.token) {
        axios
          .get(url, {})
          .then(response => {
            if (response.data.features.length > 0) {
              this.attribResponse = []
              this.features = []
              this.feature_index = 0
              this.queryWindowResponse = []
              this.queryWindowResponse = response
              this.populateQueryWindow(response, 'IMAGE', geoserverName)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async addHexagonSymbolizer(featureCoordinates) {
      // Create point vector layer (hexagon) of clicked feature
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              type: 'geoMarker',
              geometry: new Point(
                featureCoordinates
              )
            })
          ]
        }),
        zIndex: 1000,
        style: new Style({
          image: new RegularShape({
            points: 6, // Number of points for the hexagon
            radius: 14, // Radius of the hexagon
            fill: new Fill({ color: 'rgba(6, 60, 109, 0.2)' }), // Fill color
            stroke: new Stroke({ color: '#00008B', width: 2 }), // Border color and width
          })
        })
      })

      this.map.addLayer(this.vectorLayer)
    },
    showNextAttribute(value) {
      this.feature_index = value
      this.populateQueryWindow(this.queryWindowResponse, 'IMAGE')
    },
    populateQueryWindow(response, layerType, geoserverName = null) {
      let clickedLayerName
      let data = response.data
      let checkAdditionalSegment
      let site
      if (layerType == 'IMAGE') {
        this.features = data.features
        // REFACTOR -- WEBGIS-2548 -- this is not a variable in MMP.vue. Added it.
        this.fullSite = this.features[this.feature_index]
        site = this.features[this.feature_index].properties
      }
      clickedLayerName = this.features[this.feature_index]['id']
      this.clickedLayerName = clickedLayerName
      if (clickedLayerName) {
        clickedLayerName = clickedLayerName.split('.')[0]
        clickedLayerName = clickedLayerName.substr(0, 1).toUpperCase() + clickedLayerName.substr(1, clickedLayerName.length)
        this.showAttributes = true
      }
      this.attribResponse = []
      for (let key in site) {
        if (site.hasOwnProperty(key)) {
          this.attribResponse.push({
            value: site[key],
            name: key
          })
        }
      }
      
      // Get array of coordinates. Will be 2D array for linestrings.
      let geomCoordinates = this.fullSite.geometry.coordinates
      // Get length 2 array of coordinates and store them in featureCoordinates
      let featureCoordinates =
        geomCoordinates.length > 2
          ? geomCoordinates[Math.round(geomCoordinates.length / 2)]
          : geomCoordinates
      // Remove previous vectorLayer from the map
      this.map.removeLayer(this.vectorLayer)

      let coords = new fromLonLat(featureCoordinates, 'EPSG:4326')

      // Create vector layer of clicked feature
      this.addHexagonSymbolizer(coords)
    },
    handleDrag({ target, transform }) {
      target.style.transform = transform
    },
    maxOrMinAttributes(bool) {
      this.attributesPanelMinimized = bool
    },
    closeAttTable() {
      this.showAttributes = false
      this.attribResponse = null
      // Removes circle that appears on map when user inputs coordinates to zoom to
      this.map.removeLayer(this.vectorLayer)
      this.vectorLayer = null
    },
    async addPoint(feature) {
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = null

      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [feature]
        }),
        zIndex: 1000
      })

      this.map.addLayer(this.vectorLayer)
    },
    async putLayerOnTop(data) {
      this.drtLayersButtonsCtrl = this.putLayerOnTopHelper(
        this.drtLayersButtonsCtrl,
        data.payload.layerName
      )

      data.resolve();
    },
    putLayerOnTopHelper(arr, layerName) {
      for (let layerIndex in arr) {
        let layer = arr[layerIndex]
        if (layer.display_name == layerName || layer.name == layerName) {
          // Removes layer from array
          arr.splice(layerIndex, 1)
          // Adds layer back at the beginning of the array
          arr.unshift(layer)
          break
        }
      }
      return arr
    },
    
    async addPolygonToMap(attr) {
      const featureInput = attr.featureInput
      const isFileUpload = attr.isFileUpload
      if (featureInput) {
        const features = Array.isArray(featureInput)
          ? featureInput
          : [featureInput.getType && !featureInput.getId
            ? new Feature({ geometry: featureInput })
            : featureInput]

        const vectorSource = new VectorSource({ features })
        const vectorLayer = new VectorLayer({
          source: vectorSource,
          style: this.styleWKTGeometry(),
          zIndex: 1000
        })

        this.polygonVectorLayers.unshift(vectorLayer)
        this.map.addLayer(vectorLayer)
        
        if (isFileUpload) {
          this.zoomToFitFileUploadPolygons()
        } else {
          this.zoomToFitPolygons()
        }

        await this.addPolygonListener();
        await this.autoSelectUploadedPolygons(vectorLayer);
      }
    },
    async autoSelectUploadedPolygons(vectorLayer) {
      if (!this.polygonSelectEvent) return;

      const features = vectorLayer.getSource().getFeatures();
      if (!features.length) return;

      // Clear previous selections
      this.polygonsSelected = [];
      this.polygonSelectEvent.getFeatures().clear();

      // Push all uploaded polygons into the selection collection
      features.forEach((feature, index) => {
        const geomType = feature.getGeometry().getType();
        if (
          geomType === 'Polygon' ||
          geomType === 'MultiPolygon' ||
          geomType === 'LineString' ||
          geomType === 'MultiLineString'
        ) {
          this.polygonsSelected.push(feature);
          this.polygonSelectEvent.getFeatures().push(feature);

          feature.setStyle(new Style({
            fill: new Fill({ color: '#ff000033' }),
            stroke: new Stroke({ color: '#ff0000', width: 2 }),
            text: new Text({
              text: (index + 1).toString(),
              fill: new Fill({ color: '#ff0000' }),
              stroke: new Stroke({ color: '#ffffff', width: 2 }),
              font: 'bold 14px Arial',
              overflow: true
            })
          }));
        }
      });
    },
    zoomToFitPolygons() {
      if (!this.polygonVectorLayers.length) return;

      const latestLayer = this.polygonVectorLayers[0];
      const source = latestLayer.getSource();
      const features = source.getFeatures();

      if (!features.length) return

      /* ======= 
      WEBGIS-3863  
        Get only the latest geometry drawn/uploaded to the vector layers object that must be LineString / MultiLineString / Polygon / MultiPolygon to calculate the zoom level bounds. 
      ======= */
      const latestFeature = [...features].reverse().find(f => {
        const type = f.getGeometry().getType()
        return ['LineString', 'MultiLineString', 'Polygon', 'MultiPolygon'].includes(type)
      })

      if (!latestFeature) return

      // Get extent of this feature
      const extent = latestFeature.getGeometry().getExtent();

      this.map.getView().fit(extent, {
        size: this.map.getSize(), // get the actual map size to calculate zoom level for extent bounds
        padding: [100, 100, 100, 100], // smaller padding for a tighter fit
        duration: 600,
      })
    },
    zoomToFitFileUploadPolygons() {
      if (!this.polygonVectorLayers.length) return
      let combinedExtent = null

      const layer = this.polygonVectorLayers[0]
      const source = layer.getSource()
      if (source.getFeatures().length > 0) {
        source.getFeatures().forEach(feature => {
          const featureExtent = feature.getGeometry().getExtent()
          if (!combinedExtent) {
            combinedExtent = [...featureExtent]
          } else {
            combinedExtent = [
              Math.min(combinedExtent[0], featureExtent[0]),
              Math.min(combinedExtent[1], featureExtent[1]),
              Math.max(combinedExtent[2], featureExtent[2]),
              Math.max(combinedExtent[3], featureExtent[3])
            ]
          }
        })
      }

      if (combinedExtent) {
        this.map.getView().fit(combinedExtent, {
          size: this.map.getSize(), // get the actual map size to calculate zoom level for extent bounds
          padding: [100, 100, 100, 100],
          duration: 1000
        });
      }
    },
    removePolygons() {
      this.polygonVectorLayers.forEach((polygon) => {
        this.map.removeLayer(polygon)
      })
      // this.map.removeLayer(this.polygonVectorLayer)
      this.polygonVectorLayers = []
      this.polygonsSelected = []
    },
    removePolygonListener() {
      this.map.removeInteraction(this.polygonSelectEvent)
      this.polygonSelectEvent = null
      this.polygonsSelected = [];
    },
    async addPolygonListener() {
      if (this.polygonSelectEvent) {
        return;
      }
      this.polygonSelectEvent = new Select({
        condition: click,
        toggleCondition: click,  // Allows toggling selection on click
        multi: true,
        clearCondition: never,
        // Decide what geometries should be selectable.
        filter: (feature) => 
           feature.getGeometry().getType() === 'Polygon' 
        || feature.getGeometry().getType() === 'MultiPolygon' 
        || feature.getGeometry().getType() === 'LineString' 
        || feature.getGeometry().getType() === 'MultiLineString'
      });

      this.polygonSelectEvent.on('select', (e) => {
        // Apply red style to newly selected features
        e.selected.forEach(feature => {
          this.polygonsSelected.push(feature)
          feature.setStyle(new Style({
            fill: new Fill({ color: '#ff000033' }), // Red semi-transparent fill
            stroke: new Stroke({ color: '#ff0000', width: 2 }),  // Red stroke
            text: new Text({
              text: this.polygonsSelected.length.toString(),
              fill: new Fill({ color: '#ff0000' }),
              stroke: new Stroke({ color: '#ffffff', width: 2 }),
              font: 'bold 14px Arial',
              overflow: true, // ensures text is shown even if partially outside view
            })
          }));
        });

        // Reset style to yellow for deselected features
        e.deselected.forEach(feature => {
          const index = this.polygonsSelected.indexOf(feature);
          if (index > -1) {
            this.polygonsSelected.splice(index, 1);
          }
          feature.setStyle(new Style({
            fill: new Fill({ color: '#dde32933' }), // Yellow semi-transparent fill
            stroke: new Stroke({ color: '#8f9400', width: 2 })  // Yellow stroke
          }));
        });

        // Re-index and re-style all selected polygons with updated labels
        this.polygonsSelected.forEach((feature, index) => {
          feature.setStyle(new Style({
            fill: new Fill({ color: '#ff000033' }),
            stroke: new Stroke({ color: '#ff0000', width: 2 }),
            text: new Text({
              text: (index + 1).toString(),  // sequential numbering
              fill: new Fill({ color: '#ff0000' }),
              stroke: new Stroke({ color: '#ffffff', width: 2 }),
              font: 'bold 14px Arial',
              overflow: true
            })
          }));
        });
      });   

      this.map.addInteraction(this.polygonSelectEvent)
      this.polygonsSelected = []
    },
    clearPolygon(){
      this.removePolygons()
      this.removePolygonListener()
      // this.measurement = null
    },
    // WEBGIS-3793 - creating style as per the geometries inside wkt feature 
    styleWKTGeometry() {
       const style = feature => {        
        const geomType = feature.getGeometry().getType()        
        switch (geomType) {
          case 'LineString':
          case 'MultiLineString':
            return new Style({
              stroke: new Stroke({
                color: '#8f9400',
                width: 3
              })
            })
          case 'Polygon':
          case 'MultiPolygon':
            return new Style({
              fill: new Fill({ color: '#dde32933' }),
              stroke: new Stroke({ color: '#8f9400', width: 2 })
            })
          default:
            return new Style({
              stroke: new Stroke({ color: '#8f9400', width: 2 })
            })
        }
      }

      return style
    },
    acknowledgeTutorial(name) {
      if (sessionStorage.token) {
        let body = {
          name: name,
          value: true,
          user_id: this.user.id
        }
        axios.put(process.env.API_LOCATION + '/api/tutorial/acknowledge', body,
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          }
        ).then(response => {
          const content = response.data
          if (content.errors) {
            console.log(content.errors)
          }
        })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    triggerPTVTutorial() {
      this.$refs.ptvWidgets.startTutorial();
    },
    toggleLidarPanel(evt = null) {
      this.toggleLidarDownload()
      this.showLidarPanel = !this.showLidarPanel
    },
    toggleTrailsPanel(evt = null) {
      this.toggleTrailsDownload()
      this.showTrailsPanel = !this.showTrailsPanel
    },
    setLidarMinZoomAchieved(bool) {
      this.lidarMinZoomAchieved = bool
    },
    toggleLidarDownload() {
      // Lidar was off, turning it on
      if (!this.showLidarPanel) {
        this.getMapExtent()
        this.lidarDownload(this)
        // Else lidar is on, turning it off
      } else {
        // Hide any lidar on map, clear moveend listener, clear distinct_lidar arr
        this.clearLidar()
      }
    },
    toggleTrailsDownload() {
      // Lidar was off, turning it on
      if (!this.showTrailsPanel) {
        this.getMapExtent()
        this.trailDownload(this)
        // Else lidar is on, turning it off
      } else {
        // Hide any lidar on map, clear moveend listener, clear distinct_lidar arr
        this.distinct_trails = []
      }
    },
    clearLidar() {
      let lidarLayersToRemove = []
      // Get the lidar layers
      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name')
          ? layer.get('name').toString()
          : null
        if (layerNameStr && layerNameStr.includes('lidar')) {
          lidarLayersToRemove.push(layer)
        }
      })
      // Remove the lidar layers
      lidarLayersToRemove.forEach(layer => {
        this.map.removeLayer(layer)
      })

      // Clear distinct lidar arr
      this.distinct_lidar = []
    },
    getMapExtent() {
      this.extentName = this.selectedExtent
        ? this.selectedExtent
        : JSON.parse(sessionStorage.Extent)
    },
    trailDownload: async self => {
      // Only check for lidar if at appropriate zoom level
      if (self.zoomEnded >= 15) {
        // Turn on Lidar spinner since no data has loaded
        self.trailsLoading = true

        // Calculate users view extent
        let extent = self.map.getView().calculateExtent(self.map.getSize())
        // Transform extent from OSM format to lat/lon coords
        // EPSG:3857 - 'This is projected coordinate system used for rendering maps in Google Maps, OpenStreetMap, etc.' https://epsg.io/3857
        // EPSG:4326 - 'Horizontal component of 3D system. Used by the GPS satellite navigation system and for NATO military geodetic surveying.' https://epsg.io/4326
        let userExtentBoxCoords = new transformExtent(
          extent,
          'EPSG:3857',
          'EPSG:4326'
        )
        let apiUrl
        switch (self.extentName) {
          // case 'Japan':
          //   apiUrl = '/api/drt/available_lidar_japan'
          //   break
          case 'North America':
            apiUrl = '/api/drt/ptv_lidar_trails'
            break
          // case 'Europe':
          //   apiUrl = '/api/drt/available_lidar_europe'
          //   break
          // case 'Middle East':
          //   apiUrl = '/api/drt/available_lidar_middle_east'
          //   break
          // case 'Kuwait':
          //   apiUrl = '/api/drt/available_lidar_middle_east'
          //   break
          // case 'Saudi Arabia':
          //   apiUrl = '/api/drt/available_lidar_middle_east'
          //   break
        }
        if (sessionStorage.token) {
          await axios
            .get(process.env.API_LOCATION + apiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              // Four corners of users view
              params: {
                xmin: userExtentBoxCoords[0],
                ymin: userExtentBoxCoords[1],
                xmax: userExtentBoxCoords[2],
                ymax: userExtentBoxCoords[3]
              }
            })
            .then(response => {
              const content = response.data
              // If duplicate entry found, throw error and prevent submission
              if (content.errors) {
                console.log('API Call Error: ' + content.errors)
              } else {
                // Grab any expanded groups
                let expanded = []
                self.distinct_trails.forEach(lidar => {
                  if (!lidar.groupIsCollapsed) {
                    expanded.push(lidar.dateCode)
                  }
                })
                // Clearing distinct lidar after the new call has been returned
                // reduces user interface interruption
                self.distinct_trails = []

                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_trails.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_trails.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                      })
                    }
                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_trails.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_trails.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        //autoLoad: self.ansiComponent ? true : false
                      })
                    }
                  }
                })

                // Now that we have distinct lidar dates extracted in this.distinct_lidar, we can build sub nav
                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    let index = self.distinct_trails[self.distinct_trails.findIndex(x => x.dateCode == dateCode)]

                    let objToPush = {
                      pc_id: lidar.pc_id,
                      id: lidar.id
                    }

                    // index.pointcloudIDArr.push(lidar.pc_id)
                    index.pointcloudIDArr.push(objToPush)

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    let index = self.distinct_trails[self.distinct_trails.findIndex(x => x.dateCode == dateCode)]

                    let objToPush = {
                      pc_id: lidar.pc_id,
                      id: lidar.id
                    }

                    // index.pointcloudIDArr.push(lidar.pc_id)
                    index.pointcloudIDArr.push(objToPush)
                  }
                })

                // Sort distinct_lidar array so newest lidar is in index 0 and displayed first in the lidar subnav buttons
                self.distinct_trails.sort((a, b) => {
                  return parseInt(b.dateCode) - parseInt(a.dateCode)
                })

                // Re expand any previously expanded groups
                // For each lidar group, check if matches any item in expanded array we created
                self.distinct_trails.forEach(lidar => {
                  expanded.forEach(expandedGroupDateCode => {
                    // If match between distinct lidar group and a group that was previously expanded, re expand group
                    if (expandedGroupDateCode == lidar.dateCode) {
                      lidar.groupIsCollapsed = false
                    }
                  })
                })
                // Turn off Lidar spinner now that data has loaded
                self.trailsLoading = false
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
        // Else user needs to zoom in further to access lidar
      } else {
        // Clear any lidar groups, since nothing is available at users current zoom
        self.distinct_trails = []
        // self.clearLidar()
        self.trailsLoading = false
      }
    },
    lidarDownload: async self => {
      // Only check for lidar if at appropriate zoom level
      if (self.zoomEnded >= 17) {
        // Turn on Lidar spinner since no data has loaded
        self.lidarIsLoading = true

        // Calculate users view extent
        let extent = self.map.getView().calculateExtent(self.map.getSize())
        // Transform extent from OSM format to lat/lon coords
        // EPSG:3857 - 'This is projected coordinate system used for rendering maps in Google Maps, OpenStreetMap, etc.' https://epsg.io/3857
        // EPSG:4326 - 'Horizontal component of 3D system. Used by the GPS satellite navigation system and for NATO military geodetic surveying.' https://epsg.io/4326
        let userExtentBoxCoords = new transformExtent(
          extent,
          'EPSG:3857',
          'EPSG:4326'
        )
        let apiUrl
        switch (self.extentName) {
          case 'Japan':
            apiUrl = '/api/drt/available_lidar_japan'
            break
          case 'North America':
            apiUrl = '/api/drt/available_lidar'
            break
          case 'Europe':
            apiUrl = '/api/drt/available_lidar_europe'
            break
          case 'Middle East':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Kuwait':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Saudi Arabia':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
        }
        if (sessionStorage.token) {
          await axios
            .get(process.env.API_LOCATION + apiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              // Four corners of users view
              params: {
                xmin: userExtentBoxCoords[0],
                ymin: userExtentBoxCoords[1],
                xmax: userExtentBoxCoords[2],
                ymax: userExtentBoxCoords[3]
              }
            })
            .then(response => {
              const content = response.data
              // If duplicate entry found, throw error and prevent submission
              if (content.errors) {
                console.log('API Call Error: ' + content.errors)
              } else {
                // Grab any expanded groups
                let expanded = []
                self.distinct_lidar.forEach(lidar => {
                  if (!lidar.groupIsCollapsed) {
                    expanded.push(lidar.dateCode)
                  }
                })
                // Clearing distinct lidar after the new call has been returned
                // reduces user interface interruption
                self.distinct_lidar = []

                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        // autoLoad: self.ansiComponent ? true : false
                      })
                    }

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        //autoLoad: self.ansiComponent ? true : false
                      })
                    }
                  }
                })

                // Now that we have distinct lidar dates extracted in this.distinct_lidar, we can build sub nav
                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)
                  }
                })

                // Sort distinct_lidar array so newest lidar is in index 0 and displayed first in the lidar subnav buttons
                self.distinct_lidar.sort((a, b) => {
                  return parseInt(b.dateCode) - parseInt(a.dateCode)
                })

                // Re expand any previously expanded groups
                // For each lidar group, check if matches any item in expanded array we created
                self.distinct_lidar.forEach(lidar => {
                  expanded.forEach(expandedGroupDateCode => {
                    // If match between distinct lidar group and a group that was previously expanded, re expand group
                    if (expandedGroupDateCode == lidar.dateCode) {
                      lidar.groupIsCollapsed = false
                    }
                  })
                })
                // Turn off Lidar spinner now that data has loaded
                self.lidarIsLoading = false
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
        // Else user needs to zoom in further to access lidar
      } else {
        // Clear any lidar groups, since nothing is available at users current zoom
        self.distinct_lidar = []
        self.clearLidar()
        self.lidarIsLoading = false
      }
    },
    showZoomLevel() {
      this.map.on('moveend', evt => {
        this.zoomLevel = this.map.getView().getZoom()
      })
    },
    async clearCart() {
      // const temp = [...this.cart];
      // for (const cartItem of temp) {
      //   this.onPointcloudClick(cartItem);
      // }

      // Remove
      this.selectedTrails.forEach((trail) => {
        this.selectedTrailsLayer
          .getSource()
          .removeFeature(trail);
      })

      this.selectedTrails = []
      this.cart = []
      // const existingFeature = this.selectedTrails[existingIndex];

      // this.selectedTrails.splice(existingIndex, 1);
      // this.selectedTrailsLayer
      //   .getSource()
      //   .removeFeature(existingFeature);
    },
    onPointcloudClick(pointcloudID) {
      this.highlightTrail(pointcloudID);
      this.addToCart(pointcloudID, true);
    },
    highlightTrail(pointcloudID) {
      let baseUrl = 'https://geoserver-aws.ushrauto.com/geoserver/wfs';

      const params = {
        SERVICE: 'WFS',
        VERSION: '1.1.0',
        REQUEST: 'GetFeature',
        TYPENAME: 'mmp:lidar_trails',
        SRSNAME: 'EPSG:4326',
        OUTPUTFORMAT: 'application/json',
        // CQL_FILTER: `id = '${pointcloudID.id}'`,
        CQL_FILTER: `id = '${pointcloudID.id}' AND pc_id LIKE '%${pointcloudID.pc_id}%'`,
        // maxFeatures: 1,
        AUTHKEY: sessionStorage.token
      };

      // Build query string
      const queryString = new URLSearchParams(params).toString();

      // Final URL
      const url = `${baseUrl}?${queryString}`;

      axios.get(url).then(response => {
        this.selectTrail(response.data)
      });
    },
    selectTrail(data) {
      const format = new GeoJSON();
      const features = format.readFeatures(data, {
        featureProjection: this.map.getView().getProjection()
      });

      features.forEach(feature => {
        const pcId = feature.get('pc_id');

        const existingIndex = this.selectedTrails.findIndex(
          f => f.get('pc_id') === pcId
        );

        if (existingIndex !== -1) {
          // Remove
          const existingFeature = this.selectedTrails[existingIndex];

          this.selectedTrails.splice(existingIndex, 1);
          this.selectedTrailsLayer
            .getSource()
            .removeFeature(existingFeature);
        } else {
          // Add
          this.selectedTrails.push(feature);
          this.selectedTrailsLayer
            .getSource()
            .addFeature(feature);
        }
      });

      // Re-index all selected features
      this.selectedTrails.forEach((feature, i) => {
        feature.set('selectedIndex', i + 1);
      });

      this.selectedTrailsLayer.changed();
    },
    async addToCart(pointcloudID, animation) {
      const index = this.cart.findIndex(
        item => item.pc_id === pointcloudID.pc_id
      );
      if (index !== -1) {
        this.cart.splice(index, 1);
        return;
      }

      this.cart.push(pointcloudID);

      await this.$nextTick(() => {
        const targetCartEl = document.getElementById(`cart-${pointcloudID.pc_id}`);
        targetCartEl.style.visibility = 'hidden';

        const sourceEl = document.getElementById(`pc-${pointcloudID.pc_id}`);
        const cartEl = document.querySelector('.cart .cart-items');

        if (animation) {
          const sourceRect = sourceEl.getBoundingClientRect();

          const clone = sourceEl.cloneNode(true);
          clone.classList.remove('w-100');
          clone.classList.add('fly-clone');

          clone.style.position = 'fixed';
          clone.style.left = `${sourceRect.left}px`;
          clone.style.top = `${sourceRect.top}px`;
          clone.style.width = `${sourceRect.width}px`;
          clone.style.height = `${sourceRect.height}px`;
          clone.style.zIndex = 9999;

          // Explicit start state
          clone.style.transform = 'translate(0, 0) scale(1)';
          clone.style.opacity = '1';

          document.body.appendChild(clone);
          clone.getBoundingClientRect();

          // Animate to cart
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              const targetCartEl = document.getElementById(`cart-${pointcloudID.pc_id}`);
              let cartLeft, cartTop;

              if (targetCartEl) {
                const cartRect = targetCartEl.getBoundingClientRect();
                cartLeft = cartRect.left;
                cartTop = cartRect.top;
              } else {
                const cartRect = cartEl.getBoundingClientRect();
                cartLeft = cartRect.left;
                cartTop = cartRect.top;
              }

              clone.style.transform = `translate(${cartLeft - sourceRect.left}px, ${cartTop - sourceRect.top}px) scale(0.15)`;
              clone.style.opacity = '0';
            });
          });

          clone.addEventListener('transitionend', (e) => {
            if (e.propertyName !== 'transform') return;
            const targetCartEl = document.getElementById(`cart-${pointcloudID.pc_id}`);

            clone.remove();

            if (targetCartEl && targetCartEl.parentNode) {
              targetCartEl.style.visibility = 'visible';
              // Bounce the cart item on landing
              targetCartEl.style.transition = 'transform 0.25s cubic-bezier(0.36, 0.07, 0.19, 0.97)';
              targetCartEl.style.transform = 'scale(1.15)';
              setTimeout(() => {
                targetCartEl.style.transform = 'scale(1)';
                setTimeout(() => { targetCartEl.style.transition = ''; }, 250);
              }, 150);
            }
          });
        }
      });
    },
    lidarSelection(attr) {
      let wkt = attr.wkt;
      const baseUrl = 'https://geoserver-aws.ushrauto.com/geoserver/wfs';
      const params = {
        SERVICE: 'WFS',
        VERSION: '1.1.0',
        REQUEST: 'GetFeature',
        TYPENAME: 'mmp:lidar_trails',
        SRSNAME: 'EPSG:4326',
        OUTPUTFORMAT: 'application/json',
        CQL_FILTER: `INTERSECTS(wkb_geometry, SRID=4326;${wkt})`,
        AUTHKEY: sessionStorage.token
      };

      const url = `${baseUrl}?${new URLSearchParams(params).toString()}`;

      axios.get(url).then(response => {
        this.selectTrail(response.data)
        response.data.features.forEach(feature => {
          this.cart.push(feature.properties)
        })
      });
    }
  },
  computed: { 
    ...mapGetters(['globalUserRole','globalAllowedUserModules','globalIsUserAllowed', 'globalVerifyCurrentUserRole'])
  }
}
</script>
